import React, { Component } from "react";
import { API_BASE_URL, describeAIResponseError } from "../../Common/Common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Modal } from "react-bootstrap";
import AlertModal from "./AlertModal";
import PromptModal from "./PromptModal";
import MultiSelectModal from "./MultiSelectModal";
import "./Modal.css";
import "./AiDialog.css";
import { countries } from "../../Data/Countries";
import { citiesByCountry } from "../../Data/Cities";

const icoRobot     = solid("robot");
const icoChevDown  = solid("chevron-down");
const icoChevUp    = solid("chevron-up");

class AiDialog extends Component {
  constructor(props) {
    super(props);
    let city = "Florence";
    let country = "Italy";
    let attributes = window.guide_obj.attributes;
    if (attributes.cities.length > 0) city = attributes.cities[0];
    if (attributes.countries.length > 0) country = attributes.countries[0];

    let place = null;
    if (typeof this.props.id !== "undefined")
      place = window.guide_obj.places.getPlace(this.props.id);

    let location = null;
    if (typeof this.props.location !== "undefined")
      location = this.props.location;

    this.state = {
      selectedQuestion: "When is the best time to visit Florence",
      selectedNumber: "3",
      selectedCity: city,
      selectedCountry: country,
      place: place,
      location: location,
      answer: "",
      SearchText: "",
      proximity: "in",
      optionsOpen: false,
      customQuestion: "",

      AlertModalShow: false,
      activityIndicator: false,
      AlertModalTitle: "",
      AlertModalMessage: "",
      AlertModalButtons: [],

      PromptModalShow: false,
      PromptModalTitle: "Enter Value",
      PromptModalMessage: "",
      PromptModalButtons: [],
      PromptModalInputs: [],

      MultiselectItems: [],
      MultiselectSelectedItems: [],
      MultiselectMode: "uni",
      MultiselectCallback: null,
      MultiselectTitle: "Select",
      MultiselectSearchText: "",
      ShowMultiselect: false,
    };
  }

  componentDidMount() {}

  MyAlert = (message) => {
    this.setState({
      AlertModalTitle: "Message",
      AlertModalMessage: message,
      AlertModalButtons: [{ Title: "OK", Method: null }],
      AlertModalShow: true,
    });
  };

  modifyCity = () => {
    this.setState({
      PromptModalShow: true,
      PromptModalTitle: "City",
      PromptModalMessage: "Enter city Name",
      PromptModalButtons: [
        { Title: "OK", Method: this.ModifyCityCallback },
        { Title: "CANCEL", Method: null },
      ],
      PromptModalInputs: [{ name: "City Name", value: this.state.selectedCity }],
    });
  };

  ModifyCityCallback = (inputs) => {
    if (inputs === null) return;
    this.setState({ selectedCity: inputs[0].value });
  };

  modifyCountry = () => {
    this.setState({
      PromptModalShow: true,
      PromptModalTitle: "Country",
      PromptModalMessage: "Enter Country Name",
      PromptModalButtons: [
        { Title: "OK", Method: this.ModifyCountryCallback },
        { Title: "CANCEL", Method: null },
      ],
      PromptModalInputs: [{ name: "Country Name", value: this.state.selectedCountry }],
    });
  };

  ModifyCountryCallback = (inputs) => {
    if (inputs === null) return;
    this.setState({ selectedCountry: inputs[0].value });
  };

  numberChanged = (e) => {
    this.setState({ selectedNumber: e.target.value });
  };

  questionChanged = (e) => {
    let quest = e.target.value;
    if (quest === "Choose a question") return;
    this.askTheQuestion(quest);
  };

  // The question box, spinner and answer sit at the top of the scrollable
  // body — bring them into view whenever a question is asked or a sample
  // is picked from further down the list.
  _scrollToTop = () => {
    if (this._bodyRef) this._bodyRef.scrollTo({ top: 0, behavior: "smooth" });
  };

  askTheQuestion = (quest) => {
    console.log("askTheQuestion", quest);
    this._scrollToTop();
    this.setState({ selectedQuestion: quest, answer: "", activityIndicator: true });
    var url = `${API_BASE_URL}/travel_questionsGPT5.6-luna.php?q=${encodeURIComponent(`"${quest}"`)}`;
    let _this = this;
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        if (
          !response ||
          !response.choices ||
          response.choices.length === 0 ||
          !response.choices[0].message ||
          !response.choices[0].message.content
        ) {
          console.log("Error in AI response", response);
          _this.MyAlert(describeAIResponseError(response));
          _this.setState({ activityIndicator: false });
          return;
        }
        let answer = response.choices[0].message.content;
        if (answer.startsWith("\n")) answer = answer.replace("\n", "");
        if (answer.startsWith("\n")) answer = answer.replace("\n", "");
        if (answer.startsWith("Sorry")) {
          const index = answer.indexOf("[");
          if (index !== -1) {
            answer = answer.substring(index);
          } else {
            _this.setState({ activityIndicator: false });
            console.log("Error in AI response", answer);
            _this.MyAlert("Error in AI response");
            return;
          }
        }
        _this.setState({ answer, activityIndicator: false });
      })
      .catch((error) => {
        _this.setState({ answer: error.toString(), activityIndicator: false });
      });
  };

  // Earliest start / latest end across the guide's destinations, as plain
  // text for the AI's context; null when the guide has no dated destinations.
  _tripDates = () => {
    const dests = (window.guide_obj?.destinations || []).filter((d) => d.dateStart && d.dateEnd);
    if (dests.length === 0) return { dateStart: "", dateEnd: "" };
    const start = dests.reduce((a, d) => (d.dateStart < a ? d.dateStart : a), dests[0].dateStart);
    const end = dests.reduce((a, d) => (d.dateEnd > a ? d.dateEnd : a), dests[0].dateEnd);
    return { dateStart: start.toFormat("LLL d, yyyy"), dateEnd: end.toFormat("LLL d, yyyy") };
  };

  // Free-text question, answered by travel_wizard_ask.php (travel topics
  // only — it declines anything else in a normal answer, so unlike
  // askTheQuestion a reply starting with "Sorry" is shown, not treated as an
  // error).
  askCustomQuestion = () => {
    const q = this.state.customQuestion.trim();
    if (q === "" || this.state.activityIndicator) return;
    this._scrollToTop();
    this.setState({ selectedQuestion: q, answer: "", activityIndicator: true });
    fetch(`${API_BASE_URL}/travel_wizard_ask.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        q,
        city: this.state.selectedCity || "",
        country: this.state.selectedCountry || "",
        place: this.state.place?.Name || "",
        ...this._tripDates(),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        const content = response?.choices?.[0]?.message?.content;
        if (!content) {
          this.setState({ activityIndicator: false });
          this.MyAlert(response?.error && !response?.choices ? response.error : describeAIResponseError(response));
          return;
        }
        this.setState({ answer: content.replace(/^\n+/, ""), activityIndicator: false });
      })
      .catch((error) => {
        this.setState({ answer: error.toString(), activityIndicator: false });
      });
  };

  items = [
    { label: "10-day itinerary for Florence Italy in json format with: time, place and description", params: "City" },
    { label: "When is the best time to visit Florence", params: "City" },
    { label: "Top 10 Places to Visit in Florence", params: "City" },
    { label: "Top 10 popular foods in Italy", params: "Country" },
    { label: "Top 10 dishes to try in Italy", params: "Country" },
    { label: "Top 10 local dishes to try in Florence", params: "City" },
    { label: "What is the phone number for police in Florence", params: "City" },
    { label: "Top 10 attractions to visit in Florence", params: "City" },
    { label: "Top 10 attractions to visit within 100Km from Florence", params: "City" },
    { label: "What are some phone numbers for taxis in Florence", params: "City" },
    { label: "How to dial the US from Italy", params: "Country2" },
    { label: "What is the current exchange rate from dollar", params: "Currency" },
    { label: "What is the currency in Italy", params: "Country" },
    { label: "Top 10 day trips from Florence", params: "City" },
    { label: "Top 10 cities to visit near Florence", params: "City" },
    { label: "Top 10 beaches near Florence", params: "City" },
    { label: "What are some phone numbers for ambulance in Florence", params: "City" },
    { label: "Top 10 neighborhoods to stay in Florence", params: "City" },
    { label: "What is the local language in Italy", params: "Country" },
    { label: "Top 10 cities to visit in Italy", params: "Country" },
    { label: "Top 10 scenic drives near Florence Italy", params: "City" },
    { label: "Top 10 national holidays in Italy", params: "Country" },
    { label: "Is today a national holiday in Italy", params: "Country" },
    { label: "Tell me about Florence Italy", params: "City" },
    { label: "Top 10 outdoor experiences near Florence Italy", params: "City" },
    { label: "Top 10 restaurants in Florence Italy", params: "City" },
    { label: "What are the open times for Florence Italy", params: "Place" },
    { label: "Describe a 10 day itinerary, with hours, for Florence Italy", params: "City" },
    { label: "Describe a 10 day itinerary, with hours, near Florence Italy", params: "City" },
  ];

  handleSearChanged = (event) => {
    this.setState({ SearchText: event.target.value });
  };

  selectCountry = () => {
    let _countries = [];
    const countries_sorted = countries.sort();
    let id = 1;
    countries_sorted.forEach((country) =>
      _countries.push({ label: country, name: country, value: country, id: (id++).toString() })
    );
    this.MultiSelect(_countries, [], "uni", this.selectedCountry, "Select Country");
  };

  selectedCountry = (countries) => {
    let country = countries.length < 1 ? "" : countries[0].value;
    // Blanking the city on an actual country change (not a no-op reselect)
    // avoids leaving a stale city from the old country — city choices are
    // scoped to a country.
    const cityChanged = country !== this.state.selectedCountry;
    this.setState({ selectedCountry: country, selectedCity: cityChanged ? "" : this.state.selectedCity });
  };

  AI_DIALOG_CITY_OTHER = "__other__";

  // Country-first: if the country isn't picked yet, redirect there instead
  // of showing an empty/meaningless city list. Falls back to the existing
  // (previously unused) modifyCity()/ModifyCityCallback free-text prompt
  // for a country with no curated cities, or the list's own "type a
  // different city" escape hatch.
  selectCity = () => {
    const country = this.state.selectedCountry;
    if (!country) {
      this.selectCountry();
      return;
    }
    const cityList = (citiesByCountry[country] || []).slice().sort((a, b) => b.popularity - a.popularity);
    if (cityList.length === 0) {
      this.modifyCity();
      return;
    }
    const items = cityList.map((c, i) => ({ label: c.city, name: c.city, value: c.city, id: (i + 1).toString() }));
    items.push({ label: "Type a different city…", name: "other", value: this.AI_DIALOG_CITY_OTHER, id: (items.length + 1).toString() });
    this.MultiSelect(items, [], "uni", this.citySelected, `Select a city in ${country}`);
  };

  citySelected = (selected) => {
    if (!selected || selected.length === 0) return;
    if (selected[0].value === this.AI_DIALOG_CITY_OTHER) {
      this.modifyCity();
      return;
    }
    this.setState({ selectedCity: selected[0].value });
  };

  MultiSelect = (Items, SelectedItems, Mode, Callback, Title) => {
    this.setState({
      MultiselectItems: Items,
      MultiselectSelectedItems: SelectedItems,
      MultiselectMode: Mode,
      MultiselectCallback: Callback,
      MultiselectTitle: Title,
      MultiselectSearchText: "",
      ShowMultiselect: true,
    });
  };

  proximityChanged = (e) => {
    this.setState({ proximity: e.target.value });
  };

  render() {
    let questions = [];
    try {
      questions = JSON.parse(this.props.questions);
    } catch (e) {
      questions = JSON.parse(JSON.stringify(this.items));
    }
    questions = questions.sort((a, b) => (a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1));

    let _questions = [];
    for (let i = 0; i < questions.length; i++) {
      if (this.state.place === null && questions[i].params === "Place") continue;
      if (questions[i].label.includes("Florence"))
        questions[i].label = questions[i].label
          .replace("Florence", this.state.selectedCity)
          .replace("Italy", this.state.selectedCountry)
          .replace("10", this.state.selectedNumber)
          .replace(" in ", ` ${this.state.proximity} `);
      else
        questions[i].label = questions[i].label
          .replace("Florence", this.state.selectedCity)
          .replace("Italy", this.state.selectedCountry)
          .replace("10", this.state.selectedNumber);
      if (
        this.state.SearchText !== "" &&
        !questions[i].label.toUpperCase().includes(this.state.SearchText.toUpperCase())
      )
        continue;
      _questions.push(questions[i]);
    }

    if (this.state.AlertModalShow)
      return (
        <AlertModal
          show={this.state.AlertModalShow}
          onHide={() => this.setState({ AlertModalShow: false })}
          AlertModalTitle={this.state.AlertModalTitle}
          AlertModalMessage={this.state.AlertModalMessage}
          AlertModalButtons={this.state.AlertModalButtons}
        />
      );
    if (this.state.PromptModalShow)
      return (
        <PromptModal
          show={this.state.PromptModalShow}
          onHide={() => this.setState({ PromptModalShow: false })}
          PromptModalTitle={this.state.PromptModalTitle}
          PromptModalMessage={this.state.PromptModalMessage}
          PromptModalButtons={this.state.PromptModalButtons}
          PromptModalInputs={this.state.PromptModalInputs}
        />
      );
    if (this.state.ShowMultiselect)
      return (
        <MultiSelectModal
          show={this.state.ShowMultiselect}
          onHide={() => this.setState({ ShowMultiselect: false })}
          MultiselectItems={this.state.MultiselectItems}
          MultiselectSelectedItems={this.state.MultiselectSelectedItems}
          MultiselectMode={this.state.MultiselectMode}
          MultiselectCallback={this.state.MultiselectCallback}
          MultiselectTitle={this.state.MultiselectTitle}
          MultiselectSearchText={this.state.MultiselectSearchText}
        />
      );

    const { optionsOpen } = this.state;

    return (
      <div className="modal">
        <Modal
          {...this.props}
          animation={false}
          dialogClassName="aid-dialog"
          aria-labelledby="aid-title"
          centered
          onHide={this.props.onHide}
        >
          <Modal.Body style={{ padding: 0 }}>
            <div className="aid-shell">

              {/* ── Header ── */}
              <div className="aid-header">
                <div className="aid-header-icon">
                  <FontAwesomeIcon icon={icoRobot} />
                </div>
                <h2 className="aid-title" id="aid-title">Travel Wizard</h2>
                <input
                  className="aid-filter"
                  type="text"
                  placeholder="Filter questions…"
                  value={this.state.SearchText}
                  onChange={this.handleSearChanged}
                />
                <button className="aid-close" onClick={this.props.onHide}>
                  <FontAwesomeIcon icon={solid("xmark")} />
                </button>
              </div>

              {/* ── Scrollable body ── */}
              <div className="aid-body" ref={(r) => (this._bodyRef = r)}>

                <p className="aid-note">Queries may take 20+ seconds to complete.</p>

                {/* Ask your own question */}
                <span className="aid-section-label">Ask your own question</span>
                <div className="aid-card">
                  <div className="aid-ask">
                    <textarea
                      className="aid-ask-input"
                      rows={2}
                      maxLength={500}
                      placeholder="Ask anything about your trip — e.g. What should I pack?"
                      value={this.state.customQuestion}
                      onChange={(e) => this.setState({ customQuestion: e.target.value })}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && !e.shiftKey) {
                          e.preventDefault();
                          this.askCustomQuestion();
                        }
                      }}
                    />
                    <button
                      className="aid-ask-btn"
                      onClick={this.askCustomQuestion}
                      disabled={this.state.customQuestion.trim() === "" || this.state.activityIndicator}
                    >
                      Ask
                    </button>
                  </div>
                </div>

                {/* Loading */}
                {this.state.activityIndicator && (
                  <div className="aid-loading">
                    <div className="aid-spinner" />
                  </div>
                )}

                {/* Response — right under the question box so it's seen without scrolling. */}
                {this.state.answer !== "" && (
                  <>
                    <span className="aid-section-label">Response</span>
                    <textarea
                      className="aid-textarea"
                      value={this.state.answer}
                      readOnly
                    />
                  </>
                )}

                {/* Options */}
                <span className="aid-section-label">Options</span>
                <div className="aid-card">
                  <button
                    className="aid-options-toggle"
                    onClick={() => this.setState({ optionsOpen: !optionsOpen })}
                  >
                    <span className="aid-options-toggle-label">Customise query</span>
                    <FontAwesomeIcon
                      className="aid-options-toggle-icon"
                      icon={optionsOpen ? icoChevUp : icoChevDown}
                    />
                  </button>

                  {optionsOpen && (
                    <div className="aid-options-body">
                      <div className="aid-divider" />
                      <div className="aid-row">
                        <span className="aid-row-label">Number</span>
                        <select
                          className="aid-select"
                          onChange={this.numberChanged}
                          defaultValue={this.state.selectedNumber}
                        >
                          {[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,20].map((n) => (
                            <option key={n} value={n}>{n}</option>
                          ))}
                        </select>
                      </div>
                      <div className="aid-divider" />
                      <div className="aid-row">
                        <span className="aid-row-label">Proximity</span>
                        <select
                          className="aid-select"
                          onChange={this.proximityChanged}
                          defaultValue={this.state.proximity}
                        >
                          {["in","near","in or near","outside of","within 1 hour from","within 2 hours from","within 3 hours from"].map((p) => (
                            <option key={p} value={p}>{p}</option>
                          ))}
                        </select>
                      </div>
                      <div className="aid-divider" />
                      <div className="aid-row">
                        <span className="aid-row-label">Country</span>
                        <span className="aid-country-val">{this.state.selectedCountry}</span>
                        <button className="aid-country-btn" onClick={this.selectCountry}>
                          Change
                        </button>
                      </div>
                      <div className="aid-divider" />
                      {/* Picks from the selected country's curated city list, with a
                          "type a different city" fallback — see selectCity(). */}
                      <div className="aid-row">
                        <span className="aid-row-label">City / place</span>
                        <span className="aid-country-val">{this.state.selectedCity}</span>
                        <button className="aid-country-btn" onClick={this.selectCity}>
                          Change
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {/* Click fills the question box to edit; the arrow asks it as-is. */}
                <span className="aid-section-label">Sample questions</span>
                <div className="aid-card">
                  <ul className="aid-q-list">
                    {_questions.map((item, index) => (
                      <li
                        key={index}
                        className="aid-q-item aid-q-sample"
                        onClick={() => {
                          this.setState({ customQuestion: item.label });
                          this._scrollToTop();
                        }}
                        title="Click to edit in the question box"
                      >
                        <span className="aid-q-text">{item.label}</span>
                        <button
                          className="aid-q-run"
                          title="Ask this question"
                          aria-label={`Ask: ${item.label}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.askTheQuestion(item.label);
                          }}
                        >
                          <FontAwesomeIcon icon={solid("arrow-right")} />
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>

              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default AiDialog;
